import { Suspense } from 'react';
import { Help, type HelpProps, SelectStub, Text, VStack } from '@direct-frontend/components';
import { ProductsCardSortSelect } from './ProductsCardSortSelect';

export const ProductsCardSortSelectSuspense = () => (
    <VStack gap="6">
        <Text
            size="m"
            help={(props: HelpProps) => (
                <Help {...props} maxWidth="360">
                    Выберите, по каким параметрам товаров будут сортироваться варианты внутри карточки
                </Help>
            )}
        >
            Сортировка значений характеристик
        </Text>
        <Suspense fallback={<SelectStub color="contour" size="s" />}>
            <ProductsCardSortSelect />
        </Suspense>
    </VStack>
);
